export default __webpack_public_path__ + "2e26f576bfd62d518670e77162726479.svg";